import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  readonly version = signal<null | string>(null);

  constructor() {
    fetch('/version.json', { cache: 'no-cache' })
      .then((r): Promise<{ version?: string }> => r.json())
      .then(({ version }): void => this.version.set(version?.trim() ?? null))
      .catch((): void => undefined);
  }
}
